import { Controller } from 'stimulus';
import hasHistorySupport from '@/helpers/hasHistorySupport';
import serializeFormToObject from '@/helpers/serializeFormToObject';
import getControllerForElement from '@/helpers/getControllerForElement';

class FiltersController extends Controller {
  connect() {
    this.filter();
  }

  reset() {
    this.filterTargets.forEach((filter) => {
      filter.value = '';
    });

    const selectFilter = document.querySelector('[data-controller="tom-select"]');

    getControllerForElement(this.application, selectFilter, 'tom-select')
      .then((controller) => {
        controller.clear();
      });

    this.filter();
  }

  filter() {
    const formData = serializeFormToObject(this.formTarget);

    this.fetchPage(formData)
      .then((res) => {
        if (typeof res.results !== 'undefined') {
          this.outputResults(res.results);
        }

        if (typeof res.queryString !== 'undefined') {
          this.outputQueryString(res.queryString);
        }
      });
  }

  fetchPage(formData) {
    return new Promise((resolve, reject) => {
      const formUrl = this.formTarget.getAttribute('action');

      $.ajax({
        url: formUrl,
        data: formData,
        success: resolve,
        error: reject,
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  runOffMainThread(cb) {
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(() => {
        requestAnimationFrame(cb);
      });
      return;
    }

    setTimeout(cb);
  }

  outputResults(results) {
    this.runOffMainThread(() => {
      this.resultsTarget.innerHTML = results;
    });
  }

  outputQueryString(queryString) {
    if (!hasHistorySupport()) {
      return;
    }

    window.history.replaceState(
      null,
      null,
      queryString !== '' ? `?${queryString}` : window.location.pathname,
    );
  }

  onSubmit(e) {
    e.preventDefault();
  }
}

FiltersController.targets = [
  'form',
  'filter',
  'results',
];

export default FiltersController;
